import { Cloud, CloudDrizzle, CloudFog, CloudLightning, CloudMoon, CloudRain, CloudSun, Cloudy, Moon, Snowflake, Sun } from "lucide-react";

export const RAIN_TH = 0.1;
export const ALERT_MIN = 60;
export const POSSIBLE_POP = 0.5;
export const POSSIBLE_MAX = 120;
export const ALERT_STATES = ["incoming", "raining", "possible"];
export const WX_STORE = "kart_wx_place";
export const WX_EVENT = "kart-wx-place";
export const todayIso = () => { const n = new Date(); return `${n.getFullYear()}-${String(n.getMonth() + 1).padStart(2, "0")}-${String(n.getDate()).padStart(2, "0")}`; };

const ICONS = { "01d": Sun, "01n": Moon, "02d": CloudSun, "02n": CloudMoon, "03": Cloud, "04": Cloudy, "09": CloudDrizzle, "10": CloudRain, "11": CloudLightning, "13": Snowflake, "50": CloudFog };
export const wIcon = (code = "") => ICONS[code] || ICONS[code.slice(0, 2)] || Cloud;

export const kmh = (ms) => (ms == null ? null : Math.round(ms * 3.6));
const DIRS = { it: ["N", "NE", "E", "SE", "S", "SO", "O", "NO"], en: ["N", "NE", "E", "SE", "S", "SW", "W", "NW"] };
export const windDir = (deg, lang = "it") => (DIRS[lang] || DIRS.it)[Math.round(((deg || 0) % 360) / 45) % 8];

export const localTime = (dt, offset, opts = { hour: "2-digit", minute: "2-digit" }) =>
  new Date((dt + (offset || 0)) * 1000).toLocaleTimeString("it-IT", { ...opts, timeZone: "UTC" });
export const localDay = (dt, offset, lang = "it") =>
  new Date((dt + (offset || 0)) * 1000).toLocaleDateString(lang === "it" ? "it-IT" : "en-GB", { weekday: "short", day: "2-digit", timeZone: "UTC" });

export const intensity = (mmh) => (mmh < 1 ? "light" : mmh < 4 ? "moderate" : "heavy");

function possibleRain(hourly, from, nowSec) {
  const to = nowSec + POSSIBLE_MAX * 60;
  const h = (hourly || []).find((x) => x.dt < to && x.dt + 3600 > from && (x.pop || 0) >= POSSIBLE_POP);
  if (!h) return null;
  return { state: "possible", mins: Math.max(Math.round((from - nowSec) / 60), Math.round((h.dt - nowSec) / 60), 1), start: h.dt, pop: Math.round(h.pop * 100), peak: h.rain?.["1h"] || 0 };
}

export function rainOutlook(minutely, hourly, nowSec = Date.now() / 1000) {
  const m = (minutely || []).filter((x) => x.dt >= nowSec - 60);
  const near = minuteOutlook(m, nowSec);
  if (near && near.state !== "dry") return near;
  return possibleRain(hourly, m.length ? nowSec + ALERT_MIN * 60 : nowSec, nowSec) || near;
}

function minuteOutlook(m, nowSec) {
  if (!m.length) return null;
  const peakOf = (arr) => Math.max(0, ...arr.map((x) => x.precipitation || 0));
  if ((m[0].precipitation || 0) >= RAIN_TH) {
    const stop = m.findIndex((x) => (x.precipitation || 0) < RAIN_TH);
    return { state: "raining", mins: stop < 0 ? null : Math.max(1, Math.round((m[stop].dt - nowSec) / 60)), peak: peakOf(stop < 0 ? m : m.slice(0, stop)) };
  }
  const i = m.findIndex((x) => (x.precipitation || 0) >= RAIN_TH);
  if (i < 0) return { state: "dry" };
  const mins = Math.max(1, Math.round((m[i].dt - nowSec) / 60));
  return { state: mins <= ALERT_MIN ? "incoming" : "dry", mins, start: m[i].dt, peak: peakOf(m.slice(i)) };
}

export function beep() {
  const Ctx = window.AudioContext || window.webkitAudioContext;
  if (!Ctx) return;
  const ctx = new Ctx();
  [0, 0.35, 0.7].forEach((t) => {
    const o = ctx.createOscillator();
    const g = ctx.createGain();
    o.frequency.value = 880;
    g.gain.setValueAtTime(0.25, ctx.currentTime + t);
    g.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + t + 0.28);
    o.connect(g).connect(ctx.destination);
    o.start(ctx.currentTime + t);
    o.stop(ctx.currentTime + t + 0.3);
  });
  setTimeout(() => ctx.close(), 1500);
}
